import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material'
import React, { FC } from 'react'
import { Controller, UseControllerProps, useFormContext } from 'react-hook-form'

type FormFieldCheckboxProps = Omit<UseControllerProps, 'control'> &
    CheckboxProps & {
        label: React.ReactNode
        labelPlacement?: 'end' | 'start' | 'top' | 'bottom'
        defaultChecked?: boolean | 'S' | 'N' | null
    }

type onChange = (...event: any[]) => void

export const FormFieldCheckbox: FC<FormFieldCheckboxProps> = ({
    name,
    rules,
    label,
    defaultChecked = false,
    onChange: onChangeMiddleware,
    labelPlacement,
    ...rest
}) => {
    const { control } = useFormContext()

    const disabled = rest.disabled || (control as any)._options?.disabled

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        value: boolean,
        onChange: onChange,
    ) => {
        if (onChangeMiddleware) {
            onChangeMiddleware(
                {
                    ...event,
                    target: {
                        ...event.target,
                        value: event.target.value,
                    },
                },
                value,
            )
        }

        onChange(event, value)
    }

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={getValueChecked(defaultChecked)}
            render={({ field: { value, onChange, ...field } }) => (
                <FormControlLabel
                    control={
                        <Checkbox
                            {...rest}
                            {...field}
                            disabled={disabled}
                            checked={getValueChecked(value)}
                            onChange={event => {
                                handleChange(event, value, onChange)
                            }}
                        />
                    }
                    label={label}
                    labelPlacement={labelPlacement}
                    sx={{
                        userSelect: 'none',
                        ...rest.sx,
                    }}
                />
            )}
        />
    )
}

function getValueChecked(value: boolean | string | null): boolean | undefined {
    if (value === null) {
        return
    }

    if (typeof value === 'boolean') {
        return value
    }

    if (typeof value === 'string') {
        return value === 'S' ? true : false
    }

    return false
}
